var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "select",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c(
        "el-select",
        {
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            autofocus: _vm.autofocus,
            required: _vm.required,
            options: _vm.options,
            clearable: false,
            filterable: false
          },
          model: {
            value: _vm.select,
            callback: function($$v) {
              _vm.select = $$v
            },
            expression: "select"
          }
        },
        [
          !_vm.required
            ? _c("el-option", { attrs: { label: "", value: "" } })
            : _vm._e(),
          _vm._l(_vm.options, function(item) {
            return _c(
              "el-option",
              {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      float: "left",
                      color: "#8492a6",
                      "font-size": "13px"
                    }
                  },
                  [_vm._v(_vm._s(item.value))]
                ),
                _c(
                  "span",
                  { staticStyle: { float: "left", "margin-left": "10px" } },
                  [_vm._v(_vm._s(item.label))]
                )
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }